import { LogLevel } from '@logger/core';

export function normalizeLevel(level: LogLevel): string {
  return level.toString().toUpperCase().padEnd(6);
}
